<svg *ngIf="ready"
     class="idxsvg"
     viewBox="0 0 620 240"
     role="img"
     [attr.aria-label]="ariaLabel">
  <g>
    <line *ngFor="let g of gridLines"
          [attr.x1]="32" [attr.x2]="556"
          [attr.y1]="yFor(g)" [attr.y2]="yFor(g)"
          class="gridln"></line>
    <text *ngFor="let g of gridLines"
          [attr.x]="26" [attr.y]="yFor(g) + 3"
          class="axlab" text-anchor="end">{{g}}</text>
  </g>
  <text *ngFor="let l of yearLabels"
        [attr.x]="l.x" [attr.y]="l.y"
        [attr.text-anchor]="l.anchor || null"
        class="axlab">{{l.text}}</text>
  <path *ngFor="let p of paths" [attr.d]="p.d" [attr.class]="p.cls"></path>
  <circle *ngFor="let d of dots" [attr.cx]="d.cx" [attr.cy]="d.cy" r="2.8" [attr.class]="d.cls"></circle>
  <text *ngFor="let l of labels"
        [attr.x]="l.x" [attr.y]="l.y"
        [attr.fill]="l.fill || null"
        [attr.class]="l.cls">{{l.text}}</text>
</svg>
